import React from 'react'
import styles from '../UnderstandingOur/UnderstandingOur.module.css'

const UnderstandingOur = () => {
    return (
        <div className={styles.ContainerBox}>
            <div className={styles.Container}>
                <div className={styles.headerBar}>
                    <p>Understanding Our</p>
                    <h1>Terms and Condition</h1>
                </div>
                <div className={styles.Descriptions}>
                    <h3>Executive Summary: Safeguarding DesignersX through Comprehensive Terms of Use</h3>
                    <p>This document outlines a comprehensive Terms of Use (ToU) framework for Rexpt, an AI-powered voice platform developed by DesignersX. The ToU is designed to establish a clear and legally robust relationship between DesignersX and its users, serving as a foundational protective measure for the company. It meticulously defines user rights and responsibilities, delineates service parameters, and addresses critical aspects of data handling, intellectual property, and liability. Furthermore, this ToU is crafted to align seamlessly with DesignersX's Privacy Policy and to ensure compliance with a complex global landscape of data protection regulations, including GDPR, CCPA/CPRA, and PIPEDA. By articulating precise terms for service usage, data governance, and risk allocation, this ToU proactively mitigates potential legal exposures inherent in operating advanced AI SaaS products.</p>
                    <hr className={styles.hrLine}/>
                </div>

            </div>

        </div>
    )
}

export default UnderstandingOur
